import { Component, OnInit, Input } from '@angular/core';
import { SessionsWeek } from '../../session-weeks.service';
import { ModalService } from '@bayclubs/utils';

import { camps } from '../../../../models/models.generated';

@Component({
    selector: 'app-purchase-edit-sessions',
    templateUrl: './purchase-edit-sessions.component.html',
    styleUrls: ['./purchase-edit-sessions.component.scss'],
    standalone: false
})
export class PurchaseEditSessionsComponent implements OnInit {

    @Input()
    public cart: camps.OfficeCartInfo;

    @Input()
    public cartSummary: camps.OfficeCartSummaryInfo;

    @Input()
    public weeks: SessionsWeek[];

    constructor(private modal : ModalService) {  }

    ngOnInit() {
    }

    canRemoveOptions(): boolean {
        return this.cartSummary?.isPaymentProcessorPurchase == true;
    }
}
